import styled from 'styled-components';
import AlertTriangleFilled from 'components/icons/alertTriangleFilled';
import { CellWrapper } from '../../columns/styled';

export const ActionsCellWrapper = styled(CellWrapper)`
    justify-content: flex-start;
    padding: 0 2rem 0 0;
    gap: 1.75rem;
`;

export const AgentContent = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const ElevenLabsAvatar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    flex-shrink: 0;
    
    svg {
        width: 0.75rem;
        height: 0.75rem;
        color: #000000;
    }
`;

export const StyledWarningIcon = styled(AlertTriangleFilled)`
    width: 1.5rem;
    height: 1.5rem;
    flex-shrink: 0;
    color: #f59e42;
`;
